import { action } from 'typesafe-actions';
import { StateChangesType } from 'types/rest/analyticsTypes';
import { STATE_CHANGES_SET_IS_LOADING_DETAIL } from '../../../data/analyticsDataActionTypes';
import {
  SELECT_STATE_CHANGES_VIEW_TRIGGER,
  SET_STATE_CHANGES_ACTIVE_PAGE,
  SET_STATE_CHANGES_PAGE_SIZE,
  SET_STATE_CHANGES_SEARCH_KEYWORD,
} from 'store/analytics/ui/subViews/stateChangesView/stateChangesActionTypes';

/**
 * Select StateChanges Request in inspection view.
 * @param stateChangesType
 */
export const selectStateChangesViewTriggered = (stateChangesType: StateChangesType) =>
  action(SELECT_STATE_CHANGES_VIEW_TRIGGER, stateChangesType);

/**
 * Change active page in the StateChanges view.
 * @param activePage
 */
export const changeStateChangesViewActivePage = (activePage: number) =>
  action(SET_STATE_CHANGES_ACTIVE_PAGE, activePage);

/**
 * Update page size in StateChanges view.
 * @param pageSize
 */
export const changeStateChangesViewPageSize = (pageSize: number) => action(SET_STATE_CHANGES_PAGE_SIZE, pageSize);

/**
 * Change search keyword in StateChanges.
 * @param searchKeyword
 */
export const setStateChangesViewSearchKeyword = (searchKeyword: string) =>
  action(SET_STATE_CHANGES_SEARCH_KEYWORD, searchKeyword);

/**
 * Sets "IsLoading" StateChanges in details section.
 * @param isLoading
 */
export const setLoadingStateChangesDetail = (isLoading: boolean) =>
  action(STATE_CHANGES_SET_IS_LOADING_DETAIL, isLoading);
